import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { DefaultCard } from 'design-system';
import { ReactNode } from 'react';

const useStyles = makeStyles(() => ({
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  titleSection: { paddingBottom: 7 },
  logo: { marginRight: 11 },
}));

type Props = {
  title: string;
  iconSrc?: string;
  iconAlt?: string;
  children: ReactNode;
  icon?: IconProp;
};

const InformationCardLayout = ({
  title,
  iconAlt,
  iconSrc,
  children,
  icon,
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <DefaultCard>
      <Grid
        container
        className={classes.titleSection}
        data-testid="information-card-layout"
      >
        <Box display="flex" sx={{ width: '100%' }}>
          <Box>
            {iconSrc && (
              <img
                src={iconSrc}
                alt={iconAlt}
                className={classes.logo}
                data-testid="icon-image"
              />
            )}
            {icon && (
              <FontAwesomeIcon
                icon={icon}
                color="#0D2E68"
                size="2xl"
                style={{ marginRight: 11 }}
              />
            )}
          </Box>
          <Box flexGrow={1}>
            <Typography className={classes.titleText} data-testid="title-text">
              {title}
            </Typography>
          </Box>
        </Box>
      </Grid>
      {children}
    </DefaultCard>
  );
};

export default InformationCardLayout;
